<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  active: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  label: { type: String, default: '' },
  ariaLabel: { type: String, default: '' },
});

const { t } = useI18n();

const displayLabel = computed(
  () => props.label || t('LAIS_FILTER_BUTTON.LABEL')
);

const accessibleLabel = computed(() => props.ariaLabel || displayLabel.value);
</script>

<template>
  <button
    type="button"
    :disabled="disabled"
    :aria-label="accessibleLabel"
    :aria-pressed="active ? 'true' : 'false'"
    class="inline-flex min-h-10 items-center gap-2 rounded-lais border border-lais-border bg-white px-4 text-[13px] font-semibold text-lais-text transition-colors hover:border-lais-primary hover:bg-lais-primary-50/40 hover:text-lais-primary focus-visible:outline-none focus-visible:shadow-lais-focus disabled:cursor-not-allowed disabled:opacity-60"
    :class="{
      'border-lais-primary bg-lais-primary-50/60 text-lais-primary': active,
    }"
  >
    <span>
      <slot>
        {{ displayLabel }}
      </slot>
    </span>
    <span class="i-lucide-sliders-horizontal size-3.5" aria-hidden="true" />
  </button>
</template>
